import React from "react";
import img from "../images/services.jpg";
import Back from "../common/Back";
import "../home/featured/Featured.css";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="services">
        <Back
          name={t("services_page_title")}
          title={t("services_page_title")}
          cover={img}
        />

        {/* SERVICE 1 */}
        <div className="container-fluid mt-10 mb-10">
          <div className="container">
            <h2>{t("services_section_title")}</h2>
            <br />

            <div className="row rowflex">
              <div className="col-lg-6 imgpadding">
                <h4>{t("service1_title")}</h4>
                <br />

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  <span>{t("service1_point1")}</span>
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service1_point2")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service1_point3")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service1_point4")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service1_point5")}
                </div>

                <br />
                <button className="callbutton">
                  {t("contact_us")} &nbsp;
                  <span className="fa fa-arrow-right"></span>
                </button>
              </div>

              <div className="col-lg-6">
                <img
                  className="imgpadding1"
                  src="../images/software1.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        {/* SERVICE 2 */}
        <div className="container-fluid grayback">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <img
                  className="imgpadding1"
                  src="../images/building.png"
                  alt=""
                />
              </div>

              <div className="col-lg-6 imgpadding">
                <br />
                <h4>{t("service2_title")}</h4>
                <br />

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist1"></span>
                  <span>{t("service2_point1")}</span>
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist1"></span>
                  {t("service2_point2")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist1"></span>
                  {t("service2_point3")}
                </div>

                <br />
                <button className="callbutton">
                  {t("contact_us")} &nbsp;
                  <span className="fa fa-arrow-right"></span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* SERVICE 3 */}
        <div className="container-fluid mt-10 mb-10">
          <div className="container">
            <div className="row rowflex">
              <div className="col-lg-6 imgpadding">
                <h4>{t("service3_title")}</h4>
                <br />

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  <span>{t("service3_point1")}</span>
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service3_point2")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service3_point3")}
                </div>

                <br />
                <button className="callbutton">
                  {t("contact_us")} &nbsp;
                  <span className="fa fa-arrow-right"></span>
                </button>
              </div>

              <div className="col-lg-6">
                <img
                  className="imgpadding"
                  src="../images/Maintenance.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        {/* SERVICE 4 */}
        <div className="container-fluid grayback">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 imgpadding">
                <img src="../images/cloth.png" alt="" />
              </div>

              <div className="col-lg-6 imgpadding">
                <br />
                <h4>{t("service4_title")}</h4>
                <br />

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  <span>{t("service4_point1")}</span>
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service4_point2")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service4_point3")}
                </div>

                <br />
                <button className="callbutton">
                  {t("contact_us")} &nbsp;
                  <span className="fa fa-arrow-right"></span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* SERVICE 5 */}
        <div className="container-fluid mt-10 mb-10">
          <div className="container">
            <div className="row rowflex">
              <div className="col-lg-6 imgpadding">
                <h4>{t("service5_title")}</h4>
                <br />

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  <span>{t("service5_point1")}</span>
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service5_point2")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service5_point3")}
                </div>

                <br />
                <button className="callbutton">
                  {t("contact_us")} &nbsp;
                  <span className="fa fa-arrow-right"></span>
                </button>
              </div>

              <div className="col-lg-6 imgpadding">
                <img src="../images/mencloth.png" alt="" />
              </div>
            </div>
          </div>
        </div>

        {/* SERVICE 6 */}
        <div className="container-fluid grayback">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 imgpadding">
                <img src="../images/beauty.png" alt="" />
              </div>

              <div className="col-lg-6 imgpadding">
                <br />
                <h4>{t("service6_title")}</h4>
                <br />

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  <span>{t("service6_point1")}</span>
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service6_point2")}
                </div>

                <div className="servicelink">
                  <span className="fa fa-arrow-circle-right bulletlist"></span>
                  {t("service6_point3")}
                </div>

                <br />
                <button className="callbutton">
                  {t("contact_us")} &nbsp;
                  <span className="fa fa-arrow-right"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
